import { render, staticRenderFns } from "./exchangeDetail.vue?vue&type=template&id=751ed728&scoped=true"
import script from "./exchangeDetail.vue?vue&type=script&lang=js"
export * from "./exchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./exchangeDetail.vue?vue&type=style&index=0&id=751ed728&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ed728",
  null
  
)

export default component.exports